/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-plusplus */
/* eslint-disable react-hooks/exhaustive-deps */
import { BrushType } from 'pages/sessions/components/digital-coaching-tool/interface';
import * as React from 'react';
import './styles.scss';

interface Props {
  brushTypes: BrushType[],
  selectedBrushType: BrushType;
  onBrushSelect: (brushType: BrushType) => void;
  size: number;
  highlight: boolean;
  color: string;
  fullscreen: boolean;
  showSideBar: boolean;
}

// const AnnotationArea = ({
//   brushTypes, selectedBrushType, onBrushSelect, size, highlight, color,
// }: Props) => {

const AnnotationArea = React.forwardRef(({
  brushTypes, selectedBrushType, onBrushSelect, size, highlight, color, fullscreen, showSideBar,
}: Props, ref) => {
  const cursorRef = React.useRef<HTMLDivElement>(null);
  const canvasRef = React.useRef<HTMLCanvasElement>(null);
  const pointsHistory = React.useRef<any[]>([]);
  const [refreshAnnotationArea, setRefreshAnnotationArea] = React.useState(false);

  let yR = 0;
  let xR = 0;
  const highlightRadius = 40;
  let highlightStroke = 2;
  let canvas: any = null;
  let cursor: any = null;
  let ctx: any = null;
  let memCanvas: any = null;
  let memCtx: any = null;
  let points: any = [];
  let pointsMulti: any = [];
  let started = false;
  const moveCount = 0;
  let i = 0;
  let multiStarted = false;

  const drawHighlight = (x: number, y: number) => {
    if (ctx) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      // put back the saved content
      ctx.drawImage(memCanvas, 0, 0);
      // eslint-disable-next-line prefer-const
      let ctxP = ctx;
      ctxP.globalAlpha = 0.5;
      ctxP.fillStyle = '#000000';
      ctxP.beginPath();
      ctxP.arc(x, y, highlightRadius, 0, 2 * Math.PI);
      ctxP.rect(2000, 0, -2000, 2000);
      ctxP.fill();
      ctxP.closePath();
      ctxP.globalAlpha = 1;
      ctxP.beginPath();
      ctxP.arc(x, y, highlightRadius, 0, 2 * Math.PI);
      ctxP.strokeStyle = '#171772';
      ctxP.lineWidth = highlightStroke;
      ctxP.stroke();
    }
  };

  const moveMouse = (e: any) => {
    if (cursor) {
      xR = e.offsetX;
      yR = e.offsetY;
      const x = e.pageX - 8;
      const y = e.pageY - 8;

      cursor.style.transform = `translate(${x}px, ${y}px)`;
      if (highlight) {
        cursor.style.display = 'none';
        drawHighlight(xR, yR);
      } else {
        cursor.style.display = 'block';
      }
    }
  };

  const clear = () => {
    if (ctx) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
    if (memCtx) {
      memCtx.clearRect(0, 0, memCanvas.width, memCanvas.height);
    }
  };

  const canvasArrow = (
    context: any,
    fromx: number,
    fromy: number,
    tox: number,
    toy: number,
    headWidth: number,
  ) => {
    const xCenter = tox;
    const yCenter = toy;
    let angle;
    let x;
    let y;

    context.beginPath();
    context.moveTo(fromx, fromy);
    context.lineTo(tox, toy);

    angle = Math.atan2(toy - fromy, tox - fromx);
    x = headWidth * Math.cos(angle) + xCenter;
    y = headWidth * Math.sin(angle) + yCenter;

    context.moveTo(x, y);

    angle += (1.0 / 3.0) * (2 * Math.PI);
    x = headWidth * Math.cos(angle) + xCenter;
    y = headWidth * Math.sin(angle) + yCenter;

    context.lineTo(x, y);

    angle += (1.0 / 3.0) * (2 * Math.PI);
    x = headWidth * Math.cos(angle) + xCenter;
    y = headWidth * Math.sin(angle) + yCenter;

    context.lineTo(x, y);

    context.closePath();

    context.fill();
  };

  const canvasLine = (
    context: any,
    fromx: number,
    fromy: number,
    tox: number,
    toy: number,
  ) => {
    const xCenter = tox;
    const yCenter = toy;
    let angle;
    let x;
    let y;

    context.beginPath();
    context.moveTo(fromx, fromy);
    context.lineTo(tox, toy);
  };

  const canvasAngle = (
    context: any,
    fromx: number,
    fromy: number,
    tox: number,
    toy: number,
  ) => {
    const xCenter = tox;
    const yCenter = toy;
    let angle;
    let x;
    let y;

    context.beginPath();
    context.moveTo(fromx, fromy);
    context.lineTo(tox, toy);
  };

  const canvasCircle = (
    context: any,
    fromx: number,
    fromy: number,
    tox: number,
    toy: number,
  ) => {
    const centerX = (fromx + tox) / 2;
    const centerY = (fromy + toy) / 2;
    const radius = Math.sqrt(((tox - fromx) ** 2) + ((toy - fromy) ** 2)) / 2;
    context.beginPath();
    context.arc(centerX, centerY, radius, 0, 2 * Math.PI);
  };

  const canvasRect = (
    context: any,
    fromx: number,
    fromy: number,
    tox: number,
    toy: number,
  ) => {
    context.beginPath();
    context.rect(fromx, fromy, tox - fromx, toy - fromy);
  };

  const getAngle = (A1: any, A2: any, B1: any, B2: any) => {
    const dAx = A2.x - A1.x;
    const dAy = A2.y - A1.y;
    const dBx = B2.x - B1.x;
    const dBy = B2.y - B1.y;
    return Math.atan2(dAx * dBy - dAy * dBx, dAx * dBx + dAy * dBy);
  };

  const radians = (degrees: number) => (degrees * Math.PI) / 180;

  const degrees = (radiansP: number) => (radiansP * 180) / Math.PI;

  const getPoint = (pointP: any, angle: number, unit: number) => {
    let { x } = pointP;
    let { y } = pointP;
    const rad = radians(angle % 360);

    x += unit * Math.sin(rad);
    y += unit * Math.cos(rad);

    return { x, y };
  };

  const calculateAngle = (context: any) => {
    const A1 = points[0];
    const A2 = points[points.length - 1];
    const B1 = pointsMulti[0];
    const B2 = pointsMulti[pointsMulti.length - 1];
    let angle = getAngle(
      points[0],
      points[points.length - 1],
      pointsMulti[0],
      pointsMulti[pointsMulti.length - 1],
    );
    let reverse = true;

    if (angle < 0) {
      angle *= -1;
      reverse = false;
    }
    const degreesD = 180 - degrees(angle);
    const startAngle = getAngle(
      points[0],
      { x: points[0].x - 100, y: points[0].y },
      points[0],
      points[points.length - 1],
    );
    if (reverse) {
      angle = startAngle + angle - 180 * (Math.PI / 180);
    } else {
      angle = startAngle - (angle - 180 * (Math.PI / 180));
    }
    let textAngle = -degrees(startAngle) - (360 - degreesD) / 2 - 90;
    if (!reverse) {
      textAngle = -degrees(startAngle) + (360 - degreesD) / 2 - 90;
    }
    const textLocation = getPoint(pointsMulti[0], textAngle, -35);
    ctx.beginPath();
    ctx.fillStyle = '#171772';
    ctx.arc(
      pointsMulti[0].x,
      pointsMulti[0].y,
      20,
      startAngle,
      angle,
      reverse,
    );
    ctx.stroke();
    ctx.closePath();
    ctx.beginPath();
    ctx.arc(textLocation.x, textLocation.y - 4, 17, 0, 2 * Math.PI);
    ctx.fill();
    ctx.closePath();
    ctx.font = 'small-caps bold 12px Avenir';
    ctx.textAlign = 'center';
    ctx.fillStyle = '#ffffff';
    ctx.fillText(`${degreesD.toFixed(0)}°`, textLocation.x, textLocation.y);
  };

  const drawPoints = (ctxP: any, pointsP: any) => {
    if (pointsP.length < 6) return;
    if (pointsP[0].type === 'pencil') {
      if (pointsP.length < 6) {
        const b = pointsP[0];

        ctx.strokeStyle = pointsP[0].c;
        ctx.lineWidth = pointsP[0].r;
        ctxP.beginPath();
        ctxP.arc(b.x, b.y, ctxP.lineWidth / 2, 0, Math.PI * 2, !0);
        ctxP.closePath();
        ctxP.fill();
        return;
      }
      ctxP.beginPath();
      ctxP.moveTo(pointsP[0].x, pointsP[0].y);
      for (i = 1; i < pointsP.length - 2; i++) {
        ctx.strokeStyle = pointsP[i].c;
        ctx.fillStyle = pointsP[i].c;
        ctx.lineWidth = pointsP[i].r;
        const c = (pointsP[i].x + pointsP[i + 1].x) / 2;
        const d = (pointsP[i].y + pointsP[i + 1].y) / 2;
        ctxP.quadraticCurveTo(pointsP[i].x, pointsP[i].y, c, d);
      }
      ctxP.quadraticCurveTo(
        pointsP[i].x,
        pointsP[i].y,
        pointsP[i + 1].x,
        pointsP[i + 1].y,
      );
      ctxP.stroke();
    } else if (pointsP[0].type === 'arrow') {
      ctxP.beginPath();
      ctx.strokeStyle = pointsP[0].c;
      ctx.fillStyle = pointsP[0].c;
      ctx.lineWidth = pointsP[0].r;
      canvasArrow(
        ctx,
        pointsP[0].x,
        pointsP[0].y,
        pointsP[pointsP.length - 1].x,
        pointsP[pointsP.length - 1].y,
        6 + pointsP[0].r,
      );
      ctxP.stroke();
    } else if (pointsP[0].type === 'line') {
      ctxP.beginPath();
      // eslint-disable-next-line no-param-reassign
      ctxP.lineCap = 'round';
      ctx.strokeStyle = pointsP[0].c;
      ctx.fillStyle = pointsP[0].c;
      ctx.lineWidth = pointsP[0].r;
      canvasLine(
        ctx,
        pointsP[0].x,
        pointsP[0].y,
        pointsP[pointsP.length - 1].x,
        pointsP[pointsP.length - 1].y,
      );
      ctxP.stroke();
    } else if (pointsP[0].type === 'angle') {
      ctxP.beginPath();
      // eslint-disable-next-line no-param-reassign
      ctxP.lineCap = 'round';
      ctx.strokeStyle = pointsP[0].c;
      ctx.fillStyle = pointsP[0].c;
      ctx.lineWidth = pointsP[0].r;
      canvasAngle(
        ctx,
        pointsP[0].x,
        pointsP[0].y,
        pointsP[pointsP.length - 1].x,
        pointsP[pointsP.length - 1].y,
      );
      ctxP.stroke();
      if (pointsP[0].multi) {
        calculateAngle(ctxP);
      }
    } else if (pointsP[0].type === 'circle') {
      ctxP.beginPath();
      ctx.strokeStyle = pointsP[0].c;
      ctx.fillStyle = pointsP[0].c;
      ctx.lineWidth = pointsP[0].r;
      canvasCircle(
        ctx,
        pointsP[0].x,
        pointsP[0].y,
        pointsP[pointsP.length - 1].x,
        pointsP[pointsP.length - 1].y,
      );
      ctxP.stroke();
    } else if (pointsP[0].type === 'rectangle') {
      ctxP.beginPath();
      ctx.strokeStyle = pointsP[0].c;
      ctx.fillStyle = pointsP[0].c;
      ctx.lineWidth = pointsP[0].r;
      canvasRect(
        ctx,
        pointsP[0].x,
        pointsP[0].y,
        pointsP[pointsP.length - 1].x,
        pointsP[pointsP.length - 1].y,
      );
      ctxP.stroke();
    } else if (pointsP[0].type === 'circle-fill') {
      ctxP.beginPath();
      ctx.strokeStyle = pointsP[0].c;
      ctx.fillStyle = pointsP[0].c;
      ctx.lineWidth = pointsP[0].r;
      canvasCircle(
        ctx,
        pointsP[0].x,
        pointsP[0].y,
        pointsP[pointsP.length - 1].x,
        pointsP[pointsP.length - 1].y,
      );
      ctxP.fill();
    } else if (pointsP[0].type === 'rectangle-fill') {
      ctxP.beginPath();
      ctx.strokeStyle = pointsP[0].c;
      ctx.fillStyle = pointsP[0].c;
      ctx.lineWidth = pointsP[0].r;
      canvasRect(
        ctx,
        pointsP[0].x,
        pointsP[0].y,
        pointsP[pointsP.length - 1].x,
        pointsP[pointsP.length - 1].y,
      );
      ctxP.fill();
    }
  };

  // eslint-disable-next-line consistent-return
  const redraw = () => {
    clear();
    if (!pointsHistory.current) {
      return true;
    }
    for (let g = 0; g < pointsHistory.current.length; g++) {
      const d = pointsHistory.current[g];
      if (d.some((p: any) => p.multi)) {
        const n = d.filter((p: any) => !p.multi);
        const m = d.filter((p: any) => p.multi);
        points = n;
        pointsMulti = m;
        drawPoints(ctx, n);
        drawPoints(ctx, m);
        points = [];
        pointsMulti = [];
      } else {
        drawPoints(ctx, d);
      }
    }
    memCtx.drawImage(canvas, 0, 0);
  };

  const setSize = () => {
    setTimeout(() => {
      window.scrollTo(0, 0);
      canvas.width = document.querySelector('.video-wrapper')?.clientWidth;
      canvas.height = document.querySelector('.video-wrapper')?.clientHeight;
      memCanvas.width = document.querySelector('.video-wrapper')?.clientWidth;
      memCanvas.height = document.querySelector('.video-wrapper')?.clientHeight;
      redraw();
    }, 500);
  };

  const mousedown = (ev: any) => {
    if (!highlight) {
      if (multiStarted) {
        pointsMulti.push({
          x: ev._x,
          y: ev._y,
          c: color,
          r: size,
          type: selectedBrushType.name,
          multi: true,
        });
      } else {
        points.push({
          x: ev._x,
          y: ev._y,
          c: color,
          r: size,
          type: selectedBrushType.name,
          multi: false,
        });
      }
      started = true;
    } else {
      highlightStroke = 5;
      drawHighlight(xR, yR);
    }
  };

  const mousemove = (ev: any) => {
    if (!highlight) {
      moveMouse(ev);
    } else {
      redraw();
      moveMouse(ev);
    }
    if (started) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      // put back the saved content
      ctx.drawImage(memCanvas, 0, 0);
      if (multiStarted) {
        pointsMulti.push({
          x: ev._x,
          y: ev._y,
          c: color,
          r: size,
          multi: true,
        });
        drawPoints(ctx, points);
        drawPoints(ctx, pointsMulti);
      } else {
        points.push({
          x: ev._x,
          y: ev._y,
          c: color,
          r: size,
          multi: false,
        });
        drawPoints(ctx, points);
      }
    }
  };

  const mouseup = (ev: any) => {
    if (!highlight) {
      moveMouse(ev);
      if (started) {
        started = false;
        if (selectedBrushType.name === 'angle') {
          if (multiStarted) {
            multiStarted = false;
            memCtx.clearRect(
              0,
              0,
              memCanvas.width,
              memCanvas.height,
            );
            memCtx.drawImage(canvas, 0, 0);
            pointsHistory.current.push([...points, ...pointsMulti]);
            points = [];
            pointsMulti = [];
          } else {
            pointsMulti.push(points[points.length - 1]);
            pointsMulti[0].type = points[0].type;
            pointsMulti[0].multi = true;
            multiStarted = true;
          }
        } else {
          // When the pen is done, save the resulting context
          // to the in-memory canvas
          memCtx.clearRect(
            0,
            0,
            memCanvas.width,
            memCanvas.height,
          );
          memCtx.drawImage(canvas, 0, 0);
          pointsHistory.current.push(points);
          points = [];
        }
      }
    } else {
      highlightStroke = 2;
      drawHighlight(xR, yR);
    }
  };

  const evCanvas = (ev: any) => {
    if (ev.layerX || ev.layerX === 0) {
      // Firefox
      ev._x = ev.layerX;
      ev._y = ev.layerY;
    } else if (ev.offsetX || ev.offsetX === 0) {
      // Opera
      ev._x = ev.offsetX;
      ev._y = ev.offsetY;
    }

    ev._x += 0.5;
    // ev._y = ev._y + 0.5;
    // Call appropriate event handler
    if (ev.type === 'pointerdown') {
      mousedown(ev);
    }
    if (ev.type === 'pointermove') {
      mousemove(ev);
    }
    if (ev.type === 'pointerup') {
      mouseup(ev);
    }
  };

  const handleShortcut = (ev: KeyboardEvent) => {
    switch (ev.key) {
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
        onBrushSelect(brushTypes[parseInt(ev.key, 10) - 1]);
        break;
      default:
    }
  };

  const toggleHighlight = () => {
    if (!highlight) {
      if (ctx) {
        ctx.globalAlpha = 1;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        // put back the saved content
        ctx.drawImage(memCanvas, 0, 0);
      }
    }
  };

  const disableHighlight = () => {
    if (ctx) {
      ctx.globalAlpha = 1;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      // put back the saved content
      ctx.drawImage(memCanvas, 0, 0);
    }
  };

  React.useImperativeHandle(ref, () => ({
    removeAllHistory() {
      pointsHistory.current = [];
      setRefreshAnnotationArea(!refreshAnnotationArea);
    },
    removeHistoryItem() {
      const newHistory = pointsHistory.current;
      if (newHistory && newHistory.length > 0) {
        newHistory.splice(newHistory.length - 1, 1);
        pointsHistory.current = newHistory;
        setRefreshAnnotationArea(!refreshAnnotationArea);
      }
    },
  }));

  // eslint-disable-next-line consistent-return
  React.useEffect(() => {
    canvas = canvasRef.current;
    cursor = cursorRef.current;
    if (canvas) {
      ctx = canvas.getContext('2d');
      memCanvas = document.createElement('canvas');
      memCtx = memCanvas.getContext('2d');
      if (ctx) {
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
      }
      if (memCtx) {
        memCtx.lineCap = 'round';
        memCtx.lineJoin = 'round';
      }
      setSize();

      // attach the event listener
      canvas.addEventListener('pointerdown', evCanvas, true);
      canvas.addEventListener('pointermove', evCanvas, true);
      canvas.addEventListener('pointerup', evCanvas, true);
      window.addEventListener('keyup', handleShortcut, false);

      // remove the event listener
      return () => {
        canvas.removeEventListener('pointerdown', evCanvas, true);
        canvas.removeEventListener('pointermove', evCanvas, true);
        canvas.removeEventListener('pointerup', evCanvas, true);
        window.removeEventListener('keyup', handleShortcut, false);
      };
    }
  }, [selectedBrushType, size, highlight, color, refreshAnnotationArea, fullscreen, showSideBar]);

  return (
    <div className="canvas-wrapper">
      <canvas id="canvas" ref={canvasRef}> </canvas>
      <div className="cursor" ref={cursorRef} />
    </div>
  );
});

export default AnnotationArea;
